"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledProductcard = _styledComponents["default"].a.withConfig({
  displayName: "styled-simple-product-card__StyledProductcard",
  componentId: "sc-18jjmjj-0"
})(["display:inline-flex;flex-direction:column;width:100%;min-width:0;text-decoration:none;&:focus-visible{outline:2px solid var(--color-functional-focus);}&:focus:not(:focus-visible){outline:none;}"]);
var _default = exports["default"] = StyledProductcard;